import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { SharedModule } from 'src/shared/shared.module';
import { DialogAlertComponent } from '../modals/dialog-alert/dialog-alert.component';
import { DialogAlreadyExistsComponent } from '../modals/dialog-already-exists/dialog-already-exists.component';
import { DialogDeleteComponent } from '../modals/dialog-delete/dialog-delete.component';
import { DialogSaleDetailsComponent } from '../modals/dialog-sale-details/dialog-sale-details.component';
import { SupportInfoComponent } from '../modals/support/support.component';
import { AccountantComponent } from './accountant/accountant.component';
import { CepComponent } from './cep/cep.component';
import { CompanyDocumentComponent } from './company-document/company-document.component';
import { CurrencyOptionBoxComponent } from './currency-option-box/currency-option-box.component';
import { HeaderComponent } from './header/header.component';
import { InputStockQuantity } from './input-stock-quantity/input-stock-quantity.component';
import { InscricaoEstadualComponent } from './inscricao-estadual/inscricao-estadual.component';
import { LanguageOptionBoxComponent } from './language-option-box/language-option-box.component';
import { SideMenuComponent } from './side-menu/side-menu.component';
import { HelpButtonComponent } from './help-button/help-button.component';
import { HelpDialogComponent } from './help-button/help-dialog/help-dialog.component';
import { MoneyFormatPipe } from "../../pipes/money-format.pipe";
import { StockQuantityFormatPipe } from "../../pipes/stock-quantity-format.pipe";
import { ProductImportFileButtonComponent } from './product-import-file-button/product-import-file-button.component';
import { LoadingIndicatorComponent } from './loading-indicator/loading-indicator.component';
import { ProductImportHistoryDialogComponent } from './product-import-file-button/product-import-history-dialog/product-import-history-dialog.component';
import { DialogEstornoDetailsComponent } from '../modals/dialog-estorno-details/dialog-estorno-details.component';
import { DateTimeFormatPipe } from "../../pipes/datetime-format.pipe";
import { ChatbaseComponent } from './chatbase/chatbase.component';
import { OverlayModule } from "@angular/cdk/overlay";
import { TrialWarningDialogComponent } from './trial-warning-dialog/trial-warning-dialog/trial-warning-dialog.component';
import { ProductSetTaxationButton } from './set-taxation/product-set-taxation-button.component';
import { SetTaxationDialogComponent } from './set-taxation/set-taxation-dialog/set-taxation-dialog.component';
import { AuthSecondaryActionComponent } from './auth-secondary-action/auth-secondary-action.component';
import { LowercaseNoSpacesDirective } from '../directives/lowercase-no-spaces.directive';

@NgModule({
    schemas: [CUSTOM_ELEMENTS_SCHEMA],
    imports: [
    SharedModule,
    MoneyFormatPipe,
    StockQuantityFormatPipe,
    DateTimeFormatPipe,
    OverlayModule
],

    declarations: [
        SideMenuComponent,
        HeaderComponent,
        DialogDeleteComponent,
        DialogAlertComponent,
        DialogAlreadyExistsComponent,
        DialogSaleDetailsComponent,
        LanguageOptionBoxComponent,
        CurrencyOptionBoxComponent,
        CompanyDocumentComponent,
        CepComponent,
        InscricaoEstadualComponent,
        AccountantComponent,
        InputStockQuantity,
        SupportInfoComponent,
        HelpButtonComponent,
        HelpDialogComponent,
        ProductImportFileButtonComponent,
        LoadingIndicatorComponent,
        ProductImportHistoryDialogComponent,
        DialogEstornoDetailsComponent,
        ChatbaseComponent,
        TrialWarningDialogComponent,
        ProductSetTaxationButton,
        SetTaxationDialogComponent,
        AuthSecondaryActionComponent,
        LowercaseNoSpacesDirective
    ],
    exports: [
        SideMenuComponent,
        HeaderComponent,
        DialogDeleteComponent,
        DialogAlertComponent,
        DialogAlreadyExistsComponent,
        DialogSaleDetailsComponent,
        LanguageOptionBoxComponent,
        CurrencyOptionBoxComponent,
        CompanyDocumentComponent,
        CepComponent,
        InscricaoEstadualComponent,
        AccountantComponent,
        InputStockQuantity,
        HelpButtonComponent,
        ProductImportFileButtonComponent,
        LoadingIndicatorComponent,
        DialogEstornoDetailsComponent,
        ProductSetTaxationButton,
        SetTaxationDialogComponent,
        AuthSecondaryActionComponent,
        LowercaseNoSpacesDirective
    ]
})
export class ComponentsModule { }
